export const footerNavigation = [
  {
    name: 'CHIS Website',
    url: 'https://chis.scwcsu.nhs.uk/',
  },
  {
    name: 'Information & resources',
    url: 'user-guide',
  },
  {
    name: 'COVER quarterly reports',
    url: 'https://www.gov.uk/government/statistics/cover-of-vaccination-evaluated-rapidly-cover-programme-2025-to-2026-quarterly-data',
  },
  {
    name: 'Leave us feedback',
    url: 'feedback',
  },
  {
    name: 'Accessibility statement',
    url: 'accessibility',
  },
  {
    name: 'Terms and conditions',
    url: 'terms',
  },
  {
    name: "What's new",
    url: 'whats-new',
  },
  {
    name: 'Cookies',
    url: 'cookies',
  },
];
